import { FolderUploadSnapshot, ManifestEntry } from '../types';

const KEY_PREFIX = 'folder-import:';

function key(batchId: string): string {
    return `${KEY_PREFIX}${batchId}`;
}

export function saveSnapshot(snapshot: FolderUploadSnapshot): void {
    try {
        localStorage.setItem(key(snapshot.batch_id), JSON.stringify(snapshot));
    } catch {
        // localStorage may be full or disabled; recovery is best-effort.
    }
}

export function loadSnapshot(batchId: string): FolderUploadSnapshot | null {
    try {
        const raw = localStorage.getItem(key(batchId));
        if (!raw) return null;
        return JSON.parse(raw) as FolderUploadSnapshot;
    } catch {
        return null;
    }
}

export function clearSnapshot(batchId: string): void {
    try {
        localStorage.removeItem(key(batchId));
    } catch {
        // ignore
    }
}

export function listSnapshots(): FolderUploadSnapshot[] {
    const out: FolderUploadSnapshot[] = [];
    try {
        for (let i = 0; i < localStorage.length; i++) {
            const k = localStorage.key(i);
            if (!k || !k.startsWith(KEY_PREFIX)) continue;
            const raw = localStorage.getItem(k);
            if (!raw) continue;
            try {
                out.push(JSON.parse(raw) as FolderUploadSnapshot);
            } catch {
                // skip corrupt
            }
        }
    } catch {
        // ignore
    }
    return out;
}

export function appendConfirmedEntry(batchId: string, entry: ManifestEntry): void {
    const snap = loadSnapshot(batchId);
    if (!snap) return;
    const without = snap.confirmed.filter((e) => e.upload_id !== entry.upload_id);
    snap.confirmed = [...without, entry];
    saveSnapshot(snap);
}
